


















































































































































import { Component, Mixins, Watch, PropSync } from 'vue-property-decorator';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { ScreenText } from '@/lang/ScreenText';
import AccountSettings from '@/mixins/accountSettings.mixin';
import APP_CONST from '@/constants/AppConst';
import Stepper, { CheckoutStep } from '@/components/familyPortal/checkout/stepper/Stepper.vue';
import ReviewCard from '@/components/familyPortal/checkout/checkoutReviewCard/ReviewCard.vue';
import cartStore from '@/store/modules/checkout/cart/module';
import applicationStore from '@/store/modules/applications/applicationStore';
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { CatalogSession } from '@/Model/sessions/catalogTypes';
import commonEntry from '@/store/modules/commonEntry';
import MultiParticipantDiscountBadge from '@/components/familyPortal/sessionCard/MultiParticipantDiscountBadge.vue';

interface ReviewCartItem {
  session: CatalogSession;
  cartItemIds: number[];
}

@Component({
  components: {
    Spinner,
    BouncingPreloader,
    Stepper,
    ReviewCard,
    MultiParticipantDiscountBadge
  }
})
export default class CheckoutReview extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  public readonly CheckoutStep = CheckoutStep;
  public readonly screenText = new ScreenText();
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;
  public scrubComplete = false;

  /*
    TODO: this should be replaced with the actual values from the discount configuration object as soon as the BE is done
    these are mocked values for the banner message related to multiparticipant discounts
  */
  multiparticipantDiscountName = 'Sibling Discount';
  multiparticipantDiscountDescription = '15% off when you register 2 participants, 20% off when  you register 3 or more participants.';
  mutiparticipantTooltipDescription = 'Discounts will be applied after you complete applications for each participant.';

  isAutomaticDiscountEnabled = false;

  //TODO: These two values should come from the backend. With this we will know if the discount is enabled or not
  isMultiparticipantDiscountEnabled = true;
  isEarlyRegistrationDiscountEnabled = true;

  async created() {
    //FF: Automatic Discounts
    const automaticDiscountFlag = await APP_UTILITIES.getFeatureFlag(APP_CONST.FEATURE_KEYS.automaticDiscounts);
    this.isAutomaticDiscountEnabled = automaticDiscountFlag;
  }

  cartStore = cartStore;

  @Watch('activeCartId', { immediate: true })
  onActiveCartChange() {
    // this watcher will fetch the cart on component load because of cartStore.activeCartId
    // this will get destroyed when going through checkout steps and run everytime
    // this method is used for proper cart validation as well
    if (!cartStore.invalidItemsRemoved && !this.scrubComplete
      && cartStore && cartStore.activeCartId !== 0) {
      applicationStore.scrubScholarIds(cartStore.activeCartId).then(() => {
        cartStore.fetchCartForUser();
        this.scrubComplete = true;
      });
    }
  }

  get isCartEmpty(): boolean {
    return cartStore.cartItems.length == 0;
  }

  get activeCartId() {
    return cartStore.activeCartId;
  }

  get sortedCartItems(): ReviewCartItem[] {
    return cartStore.cartItemsBySession
      .map(e => ({ session: e.session, cartItemIds: e.items.map(i => i.cartItemId) }));
  }

  get checkoutSubtotalTerms(): string {
    return this.screenText.getScreenText('CHECKOUT_SUBTOTAL_TERMS');
  }

  get checkoutSubtotalText(): string {
    return this.screenText.getScreenText('CHECKOUT_SUBTOTAL_TEXT');
  }

  get subtotalCost(): string {
    return APP_UTILITIES.currencyFmt.format(cartStore.subtotal);
  }

  get isFetchingCart(): boolean {
    return cartStore.isFetchingCart;
  }

  get isInitializingCart(): boolean {
    return cartStore.isInitializingCart;
  }

  get disableNextButton(): boolean {
    return cartStore.isUpdatingCart || cartStore.isDeleting;
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor;
  }

  onClickNext() {
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_REVIEW.reviewChildSelection);
    this.$router.push(APP_CONST.APP_ROUTES.CHECKOUT_APPLY.path);
  }

  onClickTrackGoToCatalogEvent() {
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_REVIEW.viewCatalogFromCart);
    this.$router.push(this.APP_ROUTES.PROGRAMS.path);
  }

}
